import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5wxf7f7xvq: FaireBrandEntity = {
  token: "b_5wxf7f7xvq",
  type: "brand",
  name: "ChagoArt",
  avatarUrl:
    "https://cdn.faire.com/fastly/db6b250f8bd30d445157924b624107ed6e60b36e2d1f6830a20071498a0545b6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/997a8c3927b9ac7177d2110b87693758d1a4f0897aafe76b0f2132d629f1b6a8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/db6b250f8bd30d445157924b624107ed6e60b36e2d1f6830a20071498a0545b6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/997a8c3927b9ac7177d2110b87693758d1a4f0897aafe76b0f2132d629f1b6a8.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 205,
  rating: 5,
  reviewCount: 31,
  isInsider: true,
  description:
    "Welcome to ChagoArt, where craftsmanship meets creativity. We are a passionate team of artists \nand craftsmen who bring unique and beautiful pieces to life. Our journey began with a vision to \ncreate high-quality, handcrafted items that serve a functional purpose and add a touch of elegance \nand style to any home.\n\nAt ChagoArt, we believe every decor piece should tell a story. Our products are inspired by the \nbeauty of nature, the warmth of rustic charm, and the sophistication of modern design. We strive \nto create items that seamlessly blend these elements, resulting in timeless pieces that fit perfectly \nin any home setting.\n\nWe take pride in our craftsmanship. Each piece is meticulously handcrafted by skilled artisans who \nbring years of experience and a keen eye for detail to their work. From the selection of eco-friendly \nmaterials to the intricate carving and polishing, every step of our production process is done with \nthe utmost care and precision.\n\nA portion of our profits is donated to children's hospital.\n\nCustomer service: [redacted-email]",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:00.734Z",
    importedBy: "entity-db-cli",
  },
};
